import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/es/storage";

export interface INetworkStateSlice {
  connectionStatus: boolean;
  lastOnline: null | { timestamp: number; current_time: string };
}

const name = "network";
export const initialState: INetworkStateSlice = {
  connectionStatus: true,
  lastOnline: null,
};

export const networkSlice = createSlice({
  name,
  initialState,
  reducers: {
    setConnectionStatus(state, action: PayloadAction<boolean>) {
      state.connectionStatus = action.payload;
      return state;
    },

    setNetworkStatus(
      state,
      action: PayloadAction<{
        connectionStatus: boolean;
        lastOnline: null | { timestamp: number; current_time: string };
      }>
    ) {
      state.lastOnline = action.payload.lastOnline;
      state.connectionStatus = action.payload.connectionStatus;
      return state;
    },
  },
});

export const { setConnectionStatus, setNetworkStatus } = networkSlice.actions;

const persistedReducer = persistReducer(
  { key: name, storage: storage, whitelist: ["lastOnline"] },
  networkSlice.reducer
);

export default persistedReducer;
